import { BrowserRouter, Routes, Route } from "react-router-dom";
import {PersistGate} from "redux-persist/integration/react";
import {persistor} from "./redux/store.js"

import Login from "./components/Login.js";
import Register from "./components/Register.js";
import ResetPassword from "./components/ResetPassword.js";

import Layout from "./components/Layout";
import Home from "./components/Home.js";

// BREAKS ===============================================================
import Break from "./components/breaks/Breaks.js"
import BreakForm from "./components/breaks/BreakForm.js";
import BreakDetail from "./components/breaks/BreakDetail.js";

import EntryForm from "./components/entries/EntryForm.js";
import BreakEntries from "./components/entries/BreakEntries.js";

import Map from "./components/Map.js";
import Buoys from "./components/Buoys.js";
import About from "./components/About.js";
import Account from "./components/Account.js";

import Error404 from "./components/Error404";

function App() {
    return (
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path='/reset' element={<ResetPassword />} />

                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />

                    <Route path="/app" element={<Layout />}>
                        <Route path="breaks" element={<Break />} />
                        <Route path="breaks/new" element={<BreakForm />} />
                        <Route path="breaks/:id" element={<BreakDetail />} />

                        <Route path="entries/:id" element={<BreakEntries />} />
                        <Route path="newentry/:id" element={<EntryForm />} />

                        <Route path="map" element={<Map />} />
                        <Route path="buoys" element={<Buoys />} />
                        <Route path="account" element={<Account />} />
                    </Route>
                    
                    <Route path="*" element={<Error404 />} />
                </Routes>
            </BrowserRouter>
        </PersistGate>
    );
}

export default App;
